// src/pages/DocumentManagementSystem/utils/dmsRev.js
//
// Tester request (2026-10-01): a document revision is shown with two digits
// everywhere (lists, document view, printout): 1 -> "01", 12 -> "12". The
// stored value is unchanged. Anything that is not a whole number (blank,
// "—", "A") is shown as it is.
export function formatRev(value) {
    if (value === null || value === undefined) return "";
    const text = String(value).trim();
    if (text === "") return "";
    return /^\d+$/.test(text) ? text.padStart(2, "0") : text;
}

export default formatRev;
